// SaveAreascontrolcambios.tsx
import { Areascontrolcambios, AreascontrolcambiosForm } from "../../types";
import { useForm } from 'react-hook-form';
import { ROUTER_PATHS } from '@/shared';
import { useNavigate } from 'react-router-dom';
import {
	CustomTextField,
	SingleFormBoxScene,
} from '@/shared/components/ui';
import { useEffect, useState } from "react";
import { useFetchPostAreascontrolcambios, useFetchPutAreascontrolcambios } from "@/shared/actions";
import { areascontrolcambiosSchema } from "../../utils";
import { yupResolver } from "@hookform/resolvers/yup";

type SaveAreascontrolcambiosProps = {
  titulo: string
  data?: Areascontrolcambios | null
}

export default function SaveAreascontrolcambios({
  titulo, data
}: SaveAreascontrolcambiosProps) {

  	const returnUrlObservaciones = ROUTER_PATHS.control_cambios.areaNav;
    const navigate = useNavigate();
    const [shrink, setShrink] = useState(false);

    
  

  const createAreaControlCambios = useFetchPostAreascontrolcambios({
    navigate,
    returnUrl: returnUrlObservaciones,
    enableErrorRedirect:false,
  });
  ///*UPDATE/ useFetchPutAreascontrolcambios
  const updateAreaControlCambios = useFetchPutAreascontrolcambios(navigate, returnUrlObservaciones );


  //FORMULARIO
    const form = useForm<AreascontrolcambiosForm>({
      resolver: yupResolver(areascontrolcambiosSchema ),
      mode: "onChange",
      defaultValues: {
			 nombre: "",
       descripcion: "",
       activo: true,
		},
   

	});

  const {
		handleSubmit,
		reset,
		formState: { errors, isValid },
	} = form;

  const onSave = () => {
      if(!isValid) return;
      if(data?.areaId){
        return updateAreaControlCambios.mutate({
				id:data.areaId,
				data: form.getValues() as any,
			});
      }
      return createAreaControlCambios.mutate({
        ...form.getValues(),
      });
  };

  useEffect(()=>{
    if(data){
      setShrink(true);
      reset({
        ...data
      })
    }
  }, [data])

  return (
    <SingleFormBoxScene
      titlePage={titulo}
      onCancel={()=>{
        navigate(returnUrlObservaciones)
      }}
      onSave={handleSubmit(onSave)}

    >
      	<CustomTextField
				label="Nombre del area"
				name="nombre"
				control={form.control}
				defaultValue={form.getValues().nombre || ''}
				error={errors.nombre}
				helperText={errors.nombre?.message ?? ''}
				shrink={shrink}
				onChangeValue={(v)=>{
					console.log('value',v)
				}}
			/>
      <CustomTextField
				label="Descripcion del area"
				name="descripcion"
				control={form.control}
				defaultValue={form.getValues().descripcion || ''}
				error={errors.descripcion}
				helperText={errors.descripcion?.message ?? ''}
				shrink={shrink}
				onChangeValue={(v)=>{
					console.log('value',v)
				}}
			/>


    </SingleFormBoxScene>
  )
}
